/********************************************************************
 * Project: WDCK（2021）
 * Class: CalendarService
 * ----------------------------------------
 * <summary>
 * CalendarService
 * </summary>
 * <history>
 *      ThaiTV     2021/07/27      Create
 * </history>
 ********************************************************************/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EndpointsConfig } from '../../../config/endpoints.config';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(
    private http: HttpClient
  ) { }

  getNationalHoliday(request): Observable<any> {
    return this.http.post<any>(EndpointsConfig.common.getNationalHoliday, request);
  }
}
